/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CasePATCH = {
    readonly id?: number;
    /**
     * The Accession Number of the Case
     */
    readonly accession?: string | null;
    accession_prefix_id: number;
    /**
     * A secondary or external accession for the same case from the system that provided the data to WPL, e.g. Poplar, RPA.
     */
    external_accession?: string | null;
    patient_id: number;
    active_assignment_id?: number;
    screen_assignment_id?: number;
    finalize_assignment_id?: number;
    ordering_doctor_id?: number;
    supervising_physician_id?: number;
    accessioning_lab_id: number;
    /**
     * date/time that we received a WPL order message indicating grossing was completed. This will match the order_message FK.
     */
    gross_completed?: string | null;
    /**
     * date/time that we received a WPL order message indicating accessioning was completed
     */
    accession_completed?: string | null;
    priority?: CasePATCH.priority;
    /**
     * current workflow status of the case
     */
    status?: CasePATCH.status;
    /**
     * case origin, WPL or PW LIS
     */
    source?: CasePATCH.source;
    is_screening?: boolean;
    type?: CasePATCH.type;
}

export namespace CasePATCH {

    export enum priority {
        RUSH = 'rush',
        STAT = 'stat',
        NORMAL = 'normal',
    }

    /**
     * current workflow status of the case
     */
    export enum status {
        ORDERED = 'ordered',
        ACTIVE = 'active',
        WORKING = 'working',
        FLAGGED = 'flagged',
        FINALIZED = 'finalized',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        LIS_PENDING = 'lis-pending',
        ERROR = 'error',
    }

    /**
     * case origin, WPL or PW LIS
     */
    export enum source {
        WPL = 'wpl',
        PW = 'pw',
        APL = 'apl',
    }

    export enum type {
        CLINICAL = 'clinical',
        TEST = 'test',
        DEMO = 'demo',
        VALIDATION = 'validation',
        CONSULT = 'consult',
        CONTROL = 'control',
        TC_PC = 'tc-pc',
        HISTORICAL = 'historical',
    }


}
